import { render, staticRenderFns } from "./monthlyprofits_report.vue?vue&type=template&id=34fda4f4&"
import script from "./monthlyprofits_report.vue?vue&type=script&lang=js&"
export * from "./monthlyprofits_report.vue?vue&type=script&lang=js&"
import style0 from "./monthlyprofits_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports